import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Table from './table';

const LearnerCamps = () => {
  const { user } = useSelector((state) => state.authReducer);
  const [canUpdate, setCanUpdate] = useState(false);
  const [canDelete, setCanDelete] = useState(false);

  useEffect(() => {
    if (user?.permissions?.learner_camps?.add_edit) {
      setCanUpdate(true);
    }
    if (user?.permissions?.learner_camps?.delete) {
      setCanDelete(true);
    }
  }, [user]);

  return (
    <div className='page-top-div'>
      <span className='text-span'>Learner Camps Manager</span>
      <Table canUpdate={canUpdate} canDelete={canDelete} />
    </div>
  );
};

export default LearnerCamps;
